import templates from '../templates';

class CustomColumns {
  #instance;

  init(instance) {
    this.#instance = instance;
    this.#initColumn(instance.ganttDataApi.getColumnByName('status'));
    this.#initColumn(instance.ganttDataApi.getColumnByName('priority'));
    this.#initColumn(instance.ganttDataApi.getColumnByName('jira_key'));
  }

  #initColumn(column) {
    if (!column) return;

    this.#instance.config.columns.push({
      align: 'left',
      label: __(column.locale),
      name: column.name,
      resize: true,
      hide: false,
      isShowCheckbox: true,
      isCustomColumn: true,
      control_type: (column.name === 'jira_key') ? null : column.type,
      control_options: this.#getOptionsForStatusAndPriority(column),
      control_id: column.id,
      task_types: ['task', 'milestone'],
      template: task => templates.getCustomColumnTemplate(column, this.#instance, task),
    });
  }

  #getOptionsForStatusAndPriority(column) {
    if (column.name === 'status') {
      return {
        body: {
          view: 'list',
          css: 'webix_multilist tag_multiselect',
          borderless: true,
          autoheight: true,
          yCount: 5,
          select: true,
          template(item) {
            return `<span class="tag_grid_item" style="background: ${item.color || '#55BED4'}"></span><span>${item.value}</span>`;
          },
        },
        data: column.options,
      };
    }

    if (column.name === 'priority') {
      return {
        view: 'suggest',
        body: {
          view: 'list',
          css: 'webix_multilist icon_multiselect',
          borderless: true,
          autoheight: true,
          yCount: 5,
          select: true,
          template(item) {
            return `<span class="webix_icon icon_list_item" style="background-image: url(${item.picture || item.icon || (`${GT.cdn}/imgs/medium.svg`)})"></span><span class="priority_list_item">${item.value}</span>`;
          },
          data: column.options,
        },
        data: column.options,
      };
    }

    return column.options;
  }
}

export default new CustomColumns();
